<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">

      <simple-wizard :start-index="startIndex" @update:startIndex="updateIndex" class="plat" wizardClass = "plat">
        <template slot="header"><div></div></template>

        <wizard-tab >
          <template slot="label"> {{$I18n("net_info")}} </template>
          <div>
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form" style="max-width: 400px;">
              <div class="md-layout-item md-size-85 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{$I18n("search_tag")}}</label>
                  <md-input v-model="net_tag"/>
                </md-field>
              </div>
              <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
              <div class="md-layout-item md-size-15 left-layout-item" :style="{'padding-right':0}">
                <md-button class= "left-icon md-info " @click="form_changeNetData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
            </div>
            <md-table v-model="net_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'Token'">{{ item.token }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user')+'/UID'">{{ item.user_id ?item.user_id :item.uid }}</md-table-cell>
                <md-table-cell :md-label="$I18n('data')">{{ item.simple_string }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')" class="button-box">
                  <div @click="open_modal(item)" @click.stop style='color: #00bcd4;cursor: pointer;'>
                    {{$I18n("more_info")}}
                  </div>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
          </div>
        </wizard-tab>
        <wizard-tab >
          <template slot="label"> {{$I18n("log_info")}} </template>
          <div>
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form" style="max-width: 1000px;">
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{$I18n("user_id")}}</label>
                  <md-input v-model="searchForm.user_id"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{"UID"}}</label>
                  <md-input v-model="searchForm.uid"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20 md-xsmall-size-50 left-layout-item">
                <md-field>
                  <label>{{$I18n("type")}}</label>
                  <md-select v-model="searchForm.type">
                    <md-option  :value="-1" >{{$I18n("all")}}</md-option>
                    <md-option  :value="1" >{{"APP"}}</md-option>
                    <md-option  :value="2" >{{$I18n("equipment")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-日期范围选择-创建时间 -->
              <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
                <md-field class="md-theme-default md-has-value">
                  <el-date-picker :picker-options="pickerOptions" v-model="searchForm.create_time" class="md-date-form-item" align="left" type="daterange" range-separator="~" prefixIcon="no" value-format="yyyy-MM-dd HH:mm:ss" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
                </md-field>
              </div>
              <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
              <div class="md-layout-item md-size-15 left-layout-item" :style="{'padding-right':0}">
                <md-button class= "left-icon md-info " @click="form_changeSearchData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
            </div>
            <md-table v-model="tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
                <md-table-cell :md-label="'UID'">{{ item.uid }}</md-table-cell>
                <md-table-cell :md-label="$I18n('client_logo')">{{ item.client_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('download_url')">
                  <a :href='item.url' :download='item.id'>{{$I18n("download_url")}}</a>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('log_time')">{{ item.log_time }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time }}</md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
            <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
          </div>
        </wizard-tab>

      </simple-wizard>
    </div>
    <!-- 弹窗-修改产品 -->
    <simple-modal ref="modal" :title="$I18n('details')" :right="true">
      <template slot="body">
        <pre style="padding:0 20px; background: #eeeeee; text-align: left; overflow-wrap: break-word; white-space: pre-wrap;">
          {{modalData.data_string}}
        </pre>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { timestampToString1000, formatJsonForNotes } from "@/common/tools.js";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  components: {
    SimpleWizard,
    WizardTab,
  },
  data() {
    return {
      modalData:{},
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      startIndex: 0,

      net_tag   : "",
      search_tag: "",

      searchForm : { // 表单-表单数据
        create_time : ["",""],
        user_id: "",
        uid    : "",
        type   : -1,
      },
      searchData : { // 表格-检索数据
        gmt_start: 0,
        gmt_end  : 0,
        user_id: "",
        uid    : "",
        type   : 0,
      },
      tableInitData : [], // 表格数据
      tableInitNetData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  mounted : function() {
    // this.api_getNetPageData();
    // this.api_getPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage() {
      this.api_getPageData();
    },
  },
  methods: {
    open_modal(item){
      this.modalData = item;
      this.$refs.modal.open();
    },
    api_getPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.getLogList({
          ...this.searchData,
          type     : this.searchData.type > 0 ?this.searchData.type :0,
          page_size: this.pageSize,
          page_no  : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data
          this.total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    api_getNetPageData(){
      this.$api.getDevbindList({ 
        tag : this.search_tag,
      })
        .then(this.$Then(res => {
          this.tableInitNetData = res.data;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitNetData = [];
        }))
    },
    form_changeNetData(){
      if(!this.net_tag){
        this.$errorMsg(this.$I18n("pls_search_tag"))
        return 
      }
      this.search_tag = this.net_tag;
      this.api_getNetPageData();
    },
    form_changeSearchData () { // 表单-更改查询条件(并立刻查询)
      this.searchData = {
        ...this.searchForm,
        gmt_start: new Date(this.searchForm.create_time[0]).getTime()/1000,
        gmt_end  : new Date(this.searchForm.create_time[1]).getTime()/1000,
      };
      this.currentPage = 1;
      this.api_getPageData();
    },
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
  },
  computed: {
    modalTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      return {
        state    : this.modalSearchData.state,
        gmt_start: this.modalSearchData.time[0]?(new Date(this.modalSearchData.time[0]).getTime()/1000) :"",
        gmt_end  : this.modalSearchData.time[1]?(new Date(this.modalSearchData.time[1].replace("00:00:00","23:59:59")).getTime()/1000) :"",
      }
    },
    tableData(){ // 表格-展示数据
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return this.tableInitData.map(item => {

          let type_name =  item.type == 1 ?"APP" :(item.type == 2 ?this.$I18n("equipment") :"");

          let create_time = timestampToString1000(item.gmt_create).split(" ")[0];
          let log_time = timestampToString1000(item.gmt_log).split(" ")[0];
          return {
            type_name,
            create_time,
            log_time,
            ... item,
          }
        })
      }
    },
    net_tableData(){
      return [...this.tableInitNetData].map(i => {
        let create_time = timestampToString1000(i.gmt_create);
        return {
          ...i,
          create_time,
          simple_string: JSON.stringify(i).slice(0,30)+"...",
          data_string: formatJsonForNotes(i),
        }
      });
    }
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 240px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
